import axios from 'axios';

import cfac22 from '../../cfac22';

export default function submitLeadPayment(uId, leadId, holder, brand, cardNumber, expirationDate) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      post(

        `${cfac22('API_HOST_V2')}/checkout/payment/card`,
        {
          paymentInfo: {
            leadId,
            cardInfo: {
              holder,
              brand,
              cardNumber,
              expirationDate // ex: 07/2024
            }
          }
        },
        {
          headers: { 'Full-Url': window.location.href }, withCredentials: true
        }
      ).
      then(async (result) => {
        // console.log('RESULT_CreateLead: ', result);
        resolve(result.data);
      }).
      catch((error) => {
        // console.log('ERROR_SUBMIT_LEAD: ', error);
        return reject(error.response.data);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKEN:", error);
      reject(error);
    });
  });
}
